import Layout from '@/layout';
var invoiceRouter = {
  path: '/invoice',
  component: Layout,
  redirect: '/invoice/record',
  name: 'Invoice',
  meta: {
    title: '发票管理',
    icon: 'document'
  },
  children: [{
    path: 'record',
    component: function component() {
      return import('@/views/invoiceRecord/index');
    },
    name: 'InvoiceRecord',
    meta: {
      title: '发票记录',
      icon: ''
    }
  }]
};
export default invoiceRouter;